import useUser from "@auth/user/useUser";
import { useVerificaPermissao } from "./usePermissoes";
import type { ISpacePermissaoTipo, ISpaceVerificaPermissaoRequest } from "@/api/space/dtos/authenticator.dto";

/**
 * Deriva o estado de permissão de uma `tag` reaproveitando `useVerificaPermissao`.
 *
 * Como `verificaPermissao` lança erro em resposta não-OK, o estado do react-query
 * traduz direto: sucesso = permitido, erro = negado (fail-closed), pendente = carregando.
 * Usuário Space e `tag` vazia são no-op (não consultam o backend).
 */
export function useCan(tag: string, tipo: ISpacePermissaoTipo = "USUARIO") {
	const { data: user } = useUser();
	const isUsuarioSpace = Boolean(user?.eh_usuario_space);
	const hasTag = !!tag;
	const idCadGrupoUsuario = user?.id_cad_grupo_usuario;

	const requestPermissao: ISpaceVerificaPermissaoRequest =
		tipo === "GRUPO"
			? {
					tipo,
					tag_permissao: tag,
					id_cad_grupo_usuario: idCadGrupoUsuario,
				}
			: {
					tipo,
					tag_permissao: tag,
				};

	const podeConsultarPermissao = tipo === "GRUPO" ? Boolean(idCadGrupoUsuario) : true;
	const consultarBackend = !isUsuarioSpace && hasTag && podeConsultarPermissao;

	const { isLoading, isError, isSuccess } = useVerificaPermissao(requestPermissao, consultarBackend);

	return {
		permitido: isUsuarioSpace || isSuccess,
		carregando: consultarBackend && isLoading,
		negado: consultarBackend && isError, // fail-closed: erro = sem permissão
	};
}
